export default __webpack_public_path__ + "static/media/Observe.48da0c99.png";